import { http } from '@/lib/http';
import type { AirportsTree } from './types';

/** The tenant's region → country → airport tree — drives the header scope picker. */
export async function fetchAirportsTree(): Promise<AirportsTree> {
  return http.get('v1/operator-context/airports-tree').json<AirportsTree>();
}
